import { ImageName } from "@mcleod/images";
import { AbstractTableHeadingButton } from "../../AbstractTableHeadingButton";
import { ButtonVariant } from "../../../../button/ButtonVariant";

export class ShareButton extends AbstractTableHeadingButton{
    override create() {
        super.create();
        this.button.setProps({
            id: `${this.table.id}-tools-buttonShare`,
            variant: ButtonVariant.round,
            enabled: false,
            imageName: ImageName.share,
            onClick: () => this.showShare(),
            tooltip: "Share the selected row"
        });
    }

    override rowSelectionChanged() {
        this.button.enabled = this.table.selectedRowCount === 1;        
    }

    public showShare() {
    }
}
